import { Row, Col, Modal, message } from "antd";
import { useTranslation } from "react-i18next";
import Title from "../../../UI/Title/Title";
import RestoreOrderLists from "./RestorOrdersLists";
import { ChangeEvent, useEffect, useState } from "react";
import { useMutation } from "react-query";
import ResetButton from "../../../UI/ResetButton/resetbutton";
import { deleteSale, getOnHoldSales, restoreSale } from "../../../../api/sales";
import { useDispatch } from "react-redux";
import { mainActions } from "../../../../store/main/mainSlice";
import { Search } from "../../../UI/Search/Search";

type propsType = {
  isRestoreOpen: boolean;
  setIsRestoreOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
interface Category {
  id: number;
  name: string;
  description: string;
}

interface Specification {
  isComponent: boolean;
  specificationId: number;
  name: string;
  extraCharge: number | null;
  quantity: number;
  notes: string;
}

interface Item {
  id: number;
  name: string;
  barcode: string;
  category: Category;
  description: string;
  image: string | null;
  cost: number;
  sku: string;
  isActive: boolean;
}

interface SaleItem {
  id: number;
  item: Item;
  quantity: number;
  cost: number;
  price: number;
  isTaxable: boolean;
  tax: number;
  discount: number | null;
  notes: string;
  isReturned: boolean;
  returnedQuantity: number;
  specifications: Specification[];
  inStockQty: number;
  deliveryCharge: number | null;
  deliveryChargeText: string | null;
  deliveryLocation: {
    id: number | null,
    location: string | null
  }
  invoiceType: {
    id: number | null,
    typeName: string | null,
    isActive: boolean | null
  }
}

const RestoreOrder = ({ isRestoreOpen, setIsRestoreOpen }: propsType) => {
  const [t] = useTranslation("common");
  const [search, setSearch] = useState("");
  const [restore, setRestore] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearch("");
    getRestoresMutation({ search: "", page });
  };

  const [tableKey, setTableKey] = useState(0);
  const [selectedKey, setSelectedKey] = useState<number | null>(null);
  const { mutateAsync: deleteSaleMutation, isLoading: isSaleDeleting } =
    useMutation("deleteSale", (id: number) => deleteSale(id));

  const {
    mutateAsync: restoreOrderMutation,
    isLoading: isSaleMutationLoading,
  } = useMutation("restoreOrder", (id: number) => restoreSale(id), {
    onSuccess: (res) => {
      dispatch(mainActions.setInvoiceNo(res.data.invoiceNo));
    },
  });
  const dispatch = useDispatch();
  const calculateExtras = (item: any): number => {
    let total = 0;

    item.specifications.map((spec: any) => (total += spec.extraCharge));

    return total;
  };

  const { mutateAsync: getRestoresMutation, isLoading: isOnHoldSalesLoading } =
    useMutation(
      "onHoldSales",
      ({ search, page }: { search: string; page: number }) =>
        getOnHoldSales(page * 10 + 10, search),
      {
        onSuccess: (res) => {
          setRestore(res);
        },
      }
    );
  useEffect(() => {
    getRestoresMutation({ search, page });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRadioChange = (record: any) => {
    setSelectedKey(record.id);
    restoreOrderMutation(record.id).then((res) => {
      const items = res.data.details.map((obj: SaleItem) => ({
        localId: obj.id,
        name: obj.item.name,
        itemId: obj.item.id,
        barcode: obj.item.barcode,
        price: obj.price,
        totalPrice: obj.price * obj.quantity,
        isTaxable: obj.isTaxable,
        extraCharge: calculateExtras(obj),
        tax: obj.tax,
        discount: obj.discount,
        notes: obj.notes,
        qty: obj.quantity,
        specifications: obj.specifications,
        cost: obj.cost,
        qtyInStock: obj.inStockQty
      }));
      dispatch(
        mainActions.addDiscount({
          amount: res?.data?.discount ?? 0,
          type: res?.data?.discountType,
        })
      );
      dispatch(
        mainActions.addDelivery({
          deliveryCharge: res.data.deliveryCharge,
          deliveryLocation: res.data.deliveryLocation,
          deliveryChargeText: res.data.deliveryChargeText
        })
      )
      dispatch(
        mainActions.setInvoiceType({
          id: res.data.invoiceType.id,
          typeName: res.data.invoiceType.typeName,
          isActive: res.data.invoiceType.isActive
        })
      )
      dispatch(mainActions.restoreOrder(items));
      dispatch(mainActions.setCustomer(res.data.customer));
      message.success({
        content: res.data.message,
        duration: 3,
        onClick: () => {
          message.destroy();
        },
      });
    }).catch(({ res }) => {
      message.error({
        content: res.data.message,
        duration: 3,
        onClick: () => {
          message.destroy();
        },
      });
    })
  };
  return (
    <Modal
      centered
      confirmLoading={isSaleMutationLoading || isSaleDeleting}
      open={isRestoreOpen}
      onCancel={() => {
        setIsRestoreOpen(false);
        document.body.classList.remove("body-scroll-lock");
      }}
      closable={false}
      maskClosable={false}
      okText={t("confirm")}
      cancelText={t("cancel")}
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          height: "40px",
          width: "100px",
        },
      }}
      width={1100}
      destroyOnClose={true}
    >
      <Row gutter={[0, 10]}>
        <Col span={24}>
          <Title title={`${t("held-orders")}`} />
        </Col>
        <Col
          className="modaltitleEdit"
          span={24}
          style={{ marginBottom: "20px" }}
        >
          {t("please-select-an-order-from-held-invoices-to-restor")}
        </Col>
        <Col span={6}>
          <Search
            value={search}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setSearch(e.target.value);
            }}
            onEnter={() => {
              getRestoresMutation({
                search,
                page,
              })
            }}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />
        </Col>
        <Col span={24}>
          <RestoreOrderLists
            setIsRestoreOpen={setIsRestoreOpen}
            tableKey={tableKey}
            onHoldSales={restore}
            isOnHoldSalesLoading={isOnHoldSalesLoading}
            page={page}
            setPage={setPage}
            getRestoresMutation={getRestoresMutation}
            selectedKey={selectedKey}
            setSelectedKey={setSelectedKey}
            onRadioChange={onRadioChange}
            isSaleDeleting={isSaleDeleting}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default RestoreOrder;
